module.exports = __webpack_public_path__ + "media/images/icons/outlined/funnel-plot-732feaa6b90867a52f5f400ca9ca9d11.svg";